import {Link, Outlet, useNavigate} from "react-router-dom";
import {useAuth} from "./AuthContext";
import React, {useEffect, useState} from "react";
import LogoutModal from "../services/modals/LogoutModal";
import api from "../utils/axios";
import "../css/button.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import DirectoryAlertsModal from "../components/DirectoryAlertsModal";
import { fetchDirectoryAlerts } from "../utils/directoryAlertsApi";


function AdminLayout() {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [user, setUser] = useState(null);
    const handleShow = () => setIsModalOpen(true)
    const handleClose = () => setIsModalOpen(false)
    const [alerts, setAlerts] = useState([]);
    const [alertsModalOpen, setAlertsModalOpen] = useState(false);
    const [alertsLoadedOnce, setAlertsLoadedOnce] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0)
        document.title = "Admin Dashboard";
        api.get("/auth/me")
            .then((res) => {
                setUser(res.data.ssh_username);
                loadAlertsAfterLoginOnly()
            })
            .catch((err) => {
                console.error(err);
            });
        }, [])


    const loadAlertsAfterLoginOnly = async () => {
        const shouldShowAlerts = sessionStorage.getItem("show_admin_alerts");

        if (shouldShowAlerts !== "1") {
            return;
        }

        sessionStorage.removeItem("show_admin_alerts");

        try {
            const data = await fetchDirectoryAlerts();
            const pendingAlerts = Array.isArray(data) ? data : [];

            setAlerts(pendingAlerts);

            if (pendingAlerts.length > 0) {
                setAlertsModalOpen(true);
            }
        } catch (err) {
            console.error("Failed to load directory alerts", err);
        }
    };


    const loadAlerts = async () => {
        try {
            const data = await fetchDirectoryAlerts();
            const pendingAlerts = Array.isArray(data) ? data : [];

            setAlerts(pendingAlerts);

            // Open modal only once after login
            if (pendingAlerts.length > 0 && !alertsLoadedOnce) {
                setAlertsModalOpen(true);
                setAlertsLoadedOnce(true);
            }
        } catch (err) {
            console.error("Failed to load directory alerts", err);
        }
    };

    const logMeOut = () => {
        setIsModalOpen(true);
        logout();
        setIsModalOpen(false);
        navigate('/');
    }


    return (
        <div style={{ padding: "30px" }}>
            <h1>Welcome {user} to the Admin Area</h1>
            <p>Select an admin section from the menu.</p>

            <nav style={{ marginBottom: "20px" }}>
                <Link to="/admin">Dashboard</Link>
                {" | "}
                <Link to="/admin/pages">Pages</Link>
                {" | "}
                <Link to="/admin/contact-messages">Contact Messages</Link>
            </nav>
            <br/>
            <button className={'button'} onClick={handleShow}>
                Logout
            </button>
            <div style={{marginTop: "75px", marginLeft: '25px', marginBottom:'30px'}}>
                <LogoutModal show={isModalOpen} handleClose={handleClose} handleLogout={logMeOut} />
            </div>
            <hr />
            {alertsModalOpen && alerts.length > 0 && (
                <DirectoryAlertsModal
                    alerts={alerts}
                    onClose={() => setAlertsModalOpen(false)}
                    onHandled={async () => {
                        await loadAlerts();
                    }}
                />
            )}
            <Outlet />
        </div>
    );
}

export default AdminLayout;